import {
    Document,
    Page,
    StyleSheet,
    Text,
    View
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        paddingTop: 22,
        paddingHorizontal: 22,
        paddingBottom: 35,
        fontSize: 9,
        fontFamily: "Helvetica"
    },

    header: {
        borderBottom: "2 solid #0B3054",
        paddingBottom: 8,
        marginBottom: 10
    },

    brand: {
        fontSize: 20,
        color: "#0B3054",
        fontWeight: "bold"
    },

    title: {
        fontSize: 12,
        color: "#666",
        marginTop: 2
    },

    filterBox: {
        border: "1 solid #D9E2EC",
        backgroundColor: "#F7F9FC",
        padding: 10,
        marginBottom: 12,
        borderRadius: 3
    },

    filterRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 6
    },

    filterLeft: {
        width: "48%"
    },

    filterRight: {
        width: "48%"
    },

    filterFull: {
        marginTop: 3
    },

    filterLabel: {
        fontSize: 8,
        color: "#666"
    },

    filterValue: {
        marginTop: 2,
        fontSize: 10,
        fontWeight: "bold",
        color: "#222",
        lineHeight: 1.3
    },
    tableHeader: {
        flexDirection: "row",
        backgroundColor: "#0B3054",
        color: "#FFF",
        minHeight: 26,
        alignItems: "center",
        fontSize: 8.5,
        fontWeight: "bold",
        paddingVertical: 4
    },

    row: {
        flexDirection: "row",
        minHeight: 26,
        borderBottom: "1 solid #E5E7EB",
        alignItems: "center",
        paddingVertical: 4
    },
    cell: {
        paddingHorizontal: 4,
    },

    even: {
        backgroundColor: "#FAFAFA"
    },

    colSr: {
        width: "5%",
        textAlign: "center",
    },

    colCode: {
        width: "10%",
        textAlign: "center",
    },
    colCollege: {
        width: "28%",
        paddingHorizontal: 3,
    },

    colBranch: {
        width: "27%",
        paddingHorizontal: 4,
    },
    colBranchCode: {
        width: "8%",
        textAlign: "center",
    },

    colSeats: {
        width: "7%",
        textAlign: "center",
    },
    Percentile: {
        width: "5%",
        textAlign: "center",
    },
    colCutoff: {
        width: "10%",
        textAlign: "center",
    },

    footer: {
        position: "absolute",
        bottom: 15,
        left: 22,
        right: 22,
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 8,
        color: "#777",
        borderTop: "1 solid #DDD",
        paddingTop: 6
    }
});

const PreferenceListPDF = ({ filters, colleges }) => (
    <Document>

        <Page size="A4" orientation="landscape" style={styles.page} wrap>

            <View style={styles.header}>
                <Text style={styles.brand}>MEDINEERAI</Text>
                <Text style={styles.title}>
                    Personalized Engineering Preference List
                </Text>
            </View>

            <View style={styles.filterBox}>

                <View style={styles.filterRow}>

                    <View style={styles.filterLeft}>
                        <Text style={styles.filterLabel}>Rank</Text>
                        <Text style={styles.filterValue}>
                            {filters?.rank}
                        </Text>
                    </View>
                    <View style={{ marginRight: 20 }}>
                        <Text style={styles.filterLabel}>Seat Type</Text>
                        <Text style={styles.filterValue}>
                            {filters?.genderType
                                ? filters?.genderType?.charAt(0)?.toUpperCase() + filters?.genderType?.slice(1)
                                : ""}
                        </Text>
                    </View>
                    <View style={{ marginRight: 20 }}>
                        <Text style={styles.filterLabel}>Category</Text>
                        <Text style={styles.filterValue}>
                            {filters?.category}
                        </Text>
                    </View>
                    <View style={styles.filterRight}>
                        <Text style={styles.filterLabel}>Generated On</Text>
                        <Text style={styles.filterValue}>
                            {new Date().toLocaleDateString("en-GB")}
                        </Text>
                    </View>

                </View>

                <View style={styles.filterFull}>
                    <Text style={styles.filterLabel}>Preferred Branches</Text>

                    <Text style={styles.filterValue}>
                        {Array.isArray(filters?.preferredBranch)
                            ? filters.preferredBranch.join(", ")
                            : filters?.preferredBranch}
                    </Text>
                </View>

                <View style={styles.filterFull}>
                    <Text style={styles.filterLabel}>Preferred Locations</Text>

                    <Text style={styles.filterValue}>
                        {Array.isArray(filters?.locationPreference)
                            ? filters.locationPreference.join(", ")
                            : filters?.locationPreference}
                    </Text>
                </View>

            </View>
            <View style={styles.tableHeader} fixed>
                <Text style={styles.colSr}>#</Text>
                <Text style={styles.colCode}>College Code</Text>
                <Text style={styles.colCollege}>College Name</Text>
                <Text style={styles.colBranch}>Branch Name</Text>
                <Text style={styles.colBranchCode}>Branch Code</Text>
                <Text style={styles.colSeats}>Seats</Text>
                <Text style={styles.colSeats}>%(ile)</Text>
                <Text style={styles.colCutoff}>Rank</Text>
            </View>

            {colleges?.map((c, index) => (
                <View
                    key={index}
                    style={[
                        styles.row,
                        index % 2 === 0 && styles.even
                    ]}
                    wrap={false}
                >
                    <Text style={styles.colSr}>
                        {index + 1}
                    </Text>

                    <Text style={styles.colCode}>
                        {c["College Code"]}
                    </Text>

                    <Text style={styles.colCollege}>
                        {c.AbbreviatedName}
                    </Text>

                    <Text style={styles.colBranch}>
                        {c.Branch}
                    </Text>

                    <Text style={styles.colBranchCode}>
                        {c["Branch Code"]}
                    </Text>

                    <Text style={styles.colSeats}>
                        {c["Seats Cap1"] ?? "N/A"}
                    </Text>
                    <Text style={styles.Percentile}>
                        {`${parseFloat(c["Highest Percentile"]).toFixed(2)}`}
                    </Text>
                    <Text style={styles.colCutoff}>
                        {Number(c["Highest Rank"])}
                    </Text>
                </View>
            ))}

            <View style={styles.footer} fixed>
                <Text>Generated by MEDINEERAI</Text>
                <Text
                    render={({ pageNumber, totalPages }) =>
                        `Page ${pageNumber} of ${totalPages}`
                    }
                />
            </View>

        </Page>

    </Document>
);

export default PreferenceListPDF;